import React from 'react';
import { Check } from 'lucide-react';
import { FadeIn } from './FadeIn';
const specialties = ['Realismo en Blanco y Negro', 'Realismo a Color', 'Blackwork & Dotwork', 'Fine Line & Micro Tatuajes', 'Tradicional & Neo-Tradicional', 'Diseños 100% Personalizados'];
export function StylesGrid() {
  return <section id="styles" className="py-[70px] px-[25px] md:py-[80px] md:px-[40px] lg:py-[100px] lg:px-[60px] bg-black" data-id="element-232">
      <div className="max-w-[800px] mx-auto" data-id="element-233">
        <FadeIn className="text-center mb-[50px]" data-id="element-234">
          <span className="inline-block text-[0.6rem] tracking-[6px] uppercase text-gold mb-[15px] font-semibold" data-id="element-235">
            Lo que hacemos
          </span>
          <h2 className="font-cinzel text-[clamp(1.8rem,4vw,3rem)] text-white uppercase tracking-[4px] mb-5" data-id="element-236">
            Todos los <span className="text-gold" data-id="element-237">Estilos</span>
          </h2>
          <div className="w-[60px] h-[2px] bg-gold mx-auto mb-8" data-id="element-238"></div>
        </FadeIn>

        <FadeIn data-id="element-239">
          <div className="border border-gold/15 bg-dark-2 p-[40px_30px] md:p-[60px_50px]" data-id="element-240">
            <p className="text-gray text-[0.95rem] leading-[2] tracking-[0.3px] mb-6" data-id="element-241">
              En{' '}
              <strong className="text-white font-semibold" data-id="element-242">
                SOLIDO TATTOO STUDIO
              </strong>{' '}
              dominamos cada estilo de tatuaje con el mismo nivel de exigencia y
              dedicación. No nos limitamos a una sola técnica — nos
              especializamos en ofrecer{' '}
              <strong className="text-white font-semibold" data-id="element-243">
                la más alta calidad artística
              </strong>{' '}
              sin importar el estilo que elijas.
            </p>

            <p className="text-gray text-[0.95rem] leading-[2] tracking-[0.3px] mb-6" data-id="element-244">
              Cada pieza es tratada como una obra única. Desde el{' '}
              <span className="text-gold" data-id="element-245">hiperrealismo más detallado</span>{' '}
              hasta el trazo más fino y delicado, nuestro compromiso es el
              mismo: precisión, limpieza y un resultado que supere tus
              expectativas. Trabajamos con los mejores materiales, equipos de
              última generación y un proceso creativo que garantiza que tu
              tatuaje sea exactamente lo que imaginaste — o mejor.
            </p>

            <p className="text-gray text-[0.95rem] leading-[2] tracking-[0.3px] mb-10" data-id="element-246">
              Con{' '}
              <strong className="text-white font-semibold" data-id="element-247">
                más de 15 años de experiencia
              </strong>
              , hemos perfeccionado cada técnica a través de la práctica
              constante y la disciplina artística. No importa si buscas un
              retrato fotorrealista, un diseño geométrico, un blackwork sólido o
              algo completamente personalizado —{' '}
              <span className="text-gold" data-id="element-248">
                aquí lo hacemos todo, y lo hacemos bien
              </span>
              .
            </p>

            <div className="w-full h-[1px] bg-gold/15 mb-10" data-id="element-249"></div>

            <h3 className="font-cinzel text-[0.85rem] text-gold uppercase tracking-[4px] mb-6" data-id="element-250">
              Nuestras Especialidades
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-[30px] gap-y-[15px]" data-id="element-251">
              {specialties.map((item, i) => <FadeIn key={i} delay={i * 0.08} data-id="element-252">
                  <div className="flex items-center gap-3 text-[0.85rem] text-gray tracking-[1px]" data-id="element-253">
                    <Check size={14} className="text-gold shrink-0" data-id="element-254" />
                    <span data-id="element-255">{item}</span>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}